module.exports = new __parcel__URL__("nagaraj.b20aa4be.png").toString();